<template>
  <div class="nav-view">
    <div class="nav-center">
      <img v-lazy="'https://public-scloudservice-1253952448.cos.ap-guangzhou.myqcloud.com/website/sy-logo.png'" alt="">
      <div class="nav-list" @mouseleave="navIndex = 0">
        <!-- <div @click="navClick(i)" :class="[{'nav-border':navIndex==i},'nav-item']" v-for="(item, i) in navData" :key="i" :value="i"> -->
        <div @click="navClick(i)" @mouseenter="enter(i)" class="nav-item" v-for="(item, i) in navData" :key="i" :value="i">
         {{ item }}
          <!-- <div class="nav-border"></div> -->
        </div>
        <div :style="{left: `${ navIndex * 90 }px`}" class="nav-border"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Nav',
  data() {
    return {
      navIndex: 0,
      navData: ['首页', '公司简介','服务内容', '联系我们'],
    }
  },
  methods: {
    navClick(val) {
      this.navIndex = val
      const navContents = document.querySelectorAll('.boxItem')
      const offsetTopArr = []

      // console.log(navContents)

      navContents.forEach((item,index) => {
        // console.log(index)
        offsetTopArr.push(item.getBoundingClientRect().top)
      })
      // console.log(offsetTopArr)

      // this.offsetTopArr = offsetTopArr

      document.body.scrollTop = offsetTopArr[val]
      document.documentElement.scrollTop = offsetTopArr[val]
      // window.scrollTo(0,1158);
    },
    enter(val) {
      this.navIndex = val
    }
    // onScroll(e) {
    //   var osTop = document.documentElement.scrollTop || document.body.srcollTop;
    //   // console.log(osTop)
    //   if(osTop < window.innerHeight) {
    //     this.navIndex = 0
    //   }
    // }
  }
}
</script>

<style scoped>
.nav-view{position: absolute;height: 60px;background: rgba(20,26,34,0.90);width: 100%;display: flex;align-items: center;justify-content: center;z-index: 99999;}
.nav-center{display: flex;justify-content: space-between;width: 60%;height: 70px;align-items: center;}
.nav-center img{width: 118px;height: 36px;}
.nav-list{display: flex;align-items: center;color: #fff;font-size: 14px;position: relative;}
.nav-item{width:90px;display: flex;flex-direction: column;justify-content: center;align-items: center;line-height: 60px;position: relative;z-index: 1000;}
/* .nav-item:hover{border-bottom: 3px solid #0092dd} */
.nav-border{background: #01A7EB;height: 60px;width: 90px;position: absolute;left: 0;top: 0;transition: left 0.3s ease;}
</style>



// WEBPACK FOOTER //
// src/components/nav.vue